module.exports = new __parcel__URL__("escape.04a5682a.svg").toString();